import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg24WalletBlue = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: "#0096ff",
      fillRule: "evenodd",
      d: "M17.27 3.2a.8.8 0 1 1 0 1.6H4.68a.873.873 0 0 0-.87.87c0 .478.392.87.87.87h13.94a3.3 3.3 0 0 1 3.3 3.3v7.88a3.3 3.3 0 0 1-3.3 3.3H5.5a3.3 3.3 0 0 1-3.3-3.3V5.68q0-.05.006-.1l.009-.043v-.03a2.474 2.474 0 0 1 2.303-2.302L4.68 3.2zM3.8 7.976v9.744a1.7 1.7 0 0 0 1.7 1.7h13.12c.911 0 1.656-.719 1.698-1.62H16a3.8 3.8 0 0 1 0-7.6h4.319l.001-.36a1.7 1.7 0 0 0-1.7-1.7H4.68a2.5 2.5 0 0 1-.78-.126zM20.2 11.8H16a2.2 2.2 0 0 0-2.194 2.043L13.8 14a2.2 2.2 0 0 0 2.2 2.2h4.2zM16 13a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24WalletBlue$1 = Svg24WalletBlue;

export { Svg24WalletBlue$1 as default };
